import { render, staticRenderFns } from "./editOption.vue?vue&type=template&id=28c63386&scoped=true&"
import script from "./editOption.vue?vue&type=script&lang=js&"
export * from "./editOption.vue?vue&type=script&lang=js&"
import style0 from "./editOption.vue?vue&type=style&index=0&id=28c63386&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c63386",
  null
  
)

export default component.exports